import React from 'react';
import { FacilityOrderTemplateItemNewFlowDeleteQuestionModalTemplate } from 'themes/application/facility-order-new-flow/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderTemplateItemNewFlowDeleteQuestionModalStore } from 'application/facility-order-new-flow/stores';

@setCurrentView((rootStore, componentProps) => new FacilityOrderTemplateItemNewFlowDeleteQuestionModalStore(rootStore, componentProps), 'facilityOrderTemplateItemNewFlowDeleteQuestionModalStore')
@observer
class FacilityOrderTemplateItemNewFlowDeleteQuestionModal extends React.Component {
    render() {
        return <FacilityOrderTemplateItemNewFlowDeleteQuestionModalTemplate {...this.props} />
    }
}

export default FacilityOrderTemplateItemNewFlowDeleteQuestionModal;
